import React from "react";
import { Container, Title, VideoBox } from "./styles";

export const ContentVideo = ({ data, title, background, color, autoplay = true, muted = true, loop = true, playsInline = true, controls = false, }) => {
  return (
    <Container background={background} className={background ? 'withPadding' : ''} color={color}>
      {title && <Title>{title}</Title>}
      <VideoBox autoPlay={autoplay} muted={muted} loop={loop} playsInline={playsInline} controls={controls} src={data}/>
    </Container>
  );
};
